import React from "react";
import { useTranslation } from "react-i18next";

const SortOrderSelect = ({ value, onChange, style = {}, selectStyle = {} }) => {
  const { t, i18n } = useTranslation("global");
  const isRTL = i18n.language === "ar";

  return (
    <label
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 6,
        minWidth: 190,
        color: "white",
        fontSize: 13,
        direction: isRTL ? "rtl" : "ltr",
        textAlign: isRTL ? "right" : "left",
        ...style,
      }}
    >
      <span>
        {t("common.sortById", {
          defaultValue: isRTL ? "ترتيب رقم السجل" : "Sort by ID",
        })}
      </span>
      <select
        value={value || "asc"}
        onChange={event => onChange?.(event.target.value)}
        style={{
          width: "100%",
          padding: "12px",
          backgroundColor: "#1a1f2e",
          border: "1px solid #333",
          borderRadius: 8,
          color: "white",
          direction: isRTL ? "rtl" : "ltr",
          ...selectStyle,
        }}
      >
        <option value="asc">
          {t("common.sortAsc", {
            defaultValue: isRTL ? "تصاعدي" : "Ascending",
          })}
        </option>
        <option value="desc">
          {t("common.sortDesc", {
            defaultValue: isRTL ? "تنازلي" : "Descending",
          })}
        </option>
      </select>
    </label>
  );
};

export default SortOrderSelect;
